module.exports = __webpack_public_path__ + "img/bg2.ea677f1f.png";